<template>
    <Modal v-model="visible"
           ref="modal"
           :loading="true"
           title="Add to container"
           width="700"
           @on-ok="onOk"
           @on-cancel="onCancel">
        <Input v-model="search"
               size="small"
               placeholder="Search by container or booking"
               style="margin-bottom: 8px;"
               search
               clearable/>

        <i-table :columns="columns"
                 :data="filteredContainers"
                 :loading="loading"
                 highlight-row
                 size="small"
                 max-height="320"
                 @on-current-change="onSelect"/>

        <p v-if="!loading && containers.length === 0" style="margin-top: 8px;">
            There are no containers with status In Yard Empty
        </p>
    </Modal>
</template>

<script>
    import {Container} from '../../../../models/Container'

    export default {
        data() {
            return {
                visible: false,
                loading: false,
                search: '',
                inventory: null,
                selected: null,
                containers: [],
                columns: [
                    {title: 'Container', key: 'number', minWidth: 120},
                    {
                        title: 'Booking',
                        key: 'booking',
                        minWidth: 120,
                        render: (h, params) => h('span', params.row.booking ? params.row.booking.number : null),
                    },
                    {title: 'Size', key: 'size', minWidth: 70},
                    {title: 'Loaded', key: 'loads_count', minWidth: 70},
                ],
            }
        },

        computed: {
            filteredContainers() {
                const search = this.search.trim().toLowerCase();
                if (!search) return this.containers;
                return this.containers.filter(item => {
                    const number = (item.number || '').toLowerCase();
                    const booking = ((item.booking || {}).number || '').toLowerCase();
                    return number.includes(search) || booking.includes(search)
                })
            },
        },

        methods: {
            open(object = null) {
                this.inventory = object && object.inventory;
                this.selected = null;
                this.search = '';
                this.visible = true;
                this.reload()
            },

            async reload() {
                this.loading = true;
                try {
                    const response = await new Container()
                        .where('state', 'in_yard_empty')
                        .with(['booking'])
                        .all();
                    this.containers = response.data || []
                } catch (err) {
                    console.warn(err)
                } finally {
                    this.loading = false
                }
            },

            onSelect(currentRow) {
                this.selected = currentRow
            },

            async onOk() {
                if (!this.selected || !this.inventory) {
                    this.$Message.warning('Select a container');
                    this.$refs.modal.buttonLoading = false;
                    return
                }

                const container = this.containers.find(item => item.id === this.selected.id);

                try {
                    await container.attachInventory(this.inventory);
                    this.visible = false;
                    this.$emit('on-ok')
                } catch (err) {
                    this.$refs.modal.buttonLoading = false;
                    throw err
                }
            },

            onCancel() {
                this.$emit('on-cancel')
            },
        }
    }
</script>
